import { createAction, props } from '@ngrx/store';
import { AuthState } from './auth.reducer';
import { ProfileDto, UpdateProfileDto } from '@shared/dto';

export const remember = createAction('@app/auth/remember', props<Pick<AuthState, 'rememberMe'>>());
export const login = createAction('@app/auth/login', props<Pick<AuthState, 'access' | 'refresh' | 'device'>>());
export const refresh = createAction('@app/auth/refresh', props<Pick<AuthState, 'access' | 'refresh'>>());
export const logout = createAction('@app/auth/logout');

export const setUserProfile = createAction('@app/auth/set/profile', props<Pick<AuthState, 'profile'>>());
export const setUserClient = createAction('@app/auth/set/client', props<Pick<AuthState, 'client'>>());
export const setUserAuthorities = createAction('@app/auth/set/authorities', props<Pick<AuthState, 'authorities'>>());
export const setUserPermissions = createAction('@app/auth/set/permissions', props<Pick<AuthState, 'permissions'>>());

export const updateProfile = createAction(
  '@app/auth/profile/update',
  props<{ dto: UpdateProfileDto }>(),
);
export const updateProfileSuccess = createAction(
  '@app/auth/profile/update/success',
  props<{ profile: ProfileDto }>(),
);
export const updateProfileFailure = createAction(
  '@app/auth/profile/update/failure',
  props<{ error: unknown }>(),
);

export const deleteAccount = createAction('@app/auth/account/delete');
export const deleteAccountSuccess = createAction('@app/auth/account/delete/success');
export const deleteAccountFailure = createAction(
  '@app/auth/account/delete/failure',
  props<{ error: unknown }>(),
);
